"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE = '__NATIVE_FILE__';
exports.URL = '__NATIVE_URL__';
exports.TEXT = '__NATIVE_TEXT__';
//# sourceMappingURL=NativeTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd-html5-backend/lib/NativeTypes.js
// module id = 235
// module chunks = 0